export default __webpack_public_path__ + "static/media/Helvetica-Neue-Light.f1279b7b.ttf";